import React, { useState } from 'react';
import { DatePicker, MuiPickersUtilsProvider } from '@material-ui/pickers';
import DateFnsUtils from '@date-io/date-fns';
import { DB_DATE_FORMAT, DISPLAY_DATE_FORMAT } from '../../../../redux/constants';
import moment from 'moment';
import {
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableRow,
  Checkbox,
  Grid,
  Paper,
  TableContainer,
  Collapse,
  Box,
  makeStyles,
  withStyles,
  Select,
  MenuItem
} from '@material-ui/core';

const useStyles = makeStyles(theme => ({
  root: {
    width: '100%',
    maxWidth: 360,
    maxHeight: 200,
    overflowY: 'scroll',
    backgroundColor: theme.palette.background.paper,
  },
  tableRoot: {
    width: '100%',
    marginTop: theme.spacing(1),
  },
  tableContainer: {
    maxHeight: '70vh',
    borderRadius: 5,
  },
}));

const StyledTableCell = withStyles(theme => ({
  head: {
    backgroundColor: theme.palette.secondary.dark,
    color: theme.palette.common.white,
    borderBottom: 'none',
  },
  body: {
    fontSize: 14,
  },
}))(TableCell);

const ProjectSelection = props => {
  const classes = useStyles();

  const [open, setOpen] = useState(false);

  return (
    <Paper className={classes.tableRoot}>
      <TableContainer className={classes.tableContainer}>
        <Table className={classes.table} stickyHeader aria-label='a dense table'>
          <TableHead>
            <TableRow>
              <StyledTableCell align='center' width="10%">Select Projects</StyledTableCell>
              <StyledTableCell align='center'>Project Name</StyledTableCell>
              <StyledTableCell align='center' width="10%">Select Default Project</StyledTableCell>
              <StyledTableCell align='center' width="20%">Onboarding Type</StyledTableCell>
              <StyledTableCell align='center' width="30%" >Milestone</StyledTableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            {(props.list || []).map((item, k) => (
              <>
                <TableRow key={k}>
                  <TableCell component='th' scope='row' align='center' >
                    <Checkbox
                      edge='start'
                      checked={item.isSelected ? true : false}
                      tabIndex={-1}
                      disableRipple
                      inputProps={{
                        'aria-labelledby': k,
                      }}
                      onClick={e => {
                        let _project = item;
                        _project.isSelected = e.target.checked ? true : false;
                        if (!_project.isSelected) {
                          _project.isDefault = false;
                        }

                        props.onSelectProject(_project);
                      }}
                    />
                  </TableCell>
                  <TableCell align='center'>{`${item.projectName}`}</TableCell>
                  <TableCell align='center'>
                    <Checkbox
                      edge='end'
                      checked={item.isDefault ? true : false}
                      disabled={!item.isSelected}
                      tabIndex={-1}
                      disableRipple
                      inputProps={{
                        'aria-labelledby': k + '-default',
                      }}
                      onChange={e => {
                        props.onProjectDefaultChange(item.projectId);
                        setOpen(!open);
                      }}
                    />
                  </TableCell>
                  <TableCell align='center'>
                    <Select  style={{width:'100%'}} 
                      name="onboardingTypeId" 
                      variant='outlined'                  
                      value={item.onboardingTypeId}
                      disabled={!item.isSelected}
                      onChange={(e)=>{
                        props.onProjectOnboardTypeChange(item.projectId,e);
                      }}                      
                    >
                      <MenuItem value=""></MenuItem>
                      {
                        props.onboardingTypes.map((item,k)=>{
                          return <MenuItem key={k} value={item.id}>{item.name}</MenuItem>
                        })
                      }
                    </Select>

                  </TableCell>
                  <TableCell>
                    <Select  style={{width:'100%'}} 
                      name="milestoneRecId"
                      variant='outlined'
                      label='Milestone'
                      value={item.milestoneRecId}
                      disabled={!item.isSelected}
                      onChange={(e)=>{
                        props.onProjectMilestoneChange(item.projectId,e);
                      }}>
                      <MenuItem value=""></MenuItem>
                      {
                        item.milestones.map((item,k)=>{
                          return <MenuItem key={k} value={item.id}>{`${item.milestoneId} - ${item.descreption}`}</MenuItem>
                        })
                      }
                    </Select>
                  </TableCell>
                </TableRow>
                {item.isDefault ? (
                  <TableRow>
                    <TableCell
                      align='center'
                      style={{
                        paddingBottom: 0,
                        paddingTop: 0,
                      }}
                      colSpan={5}
                    >
                      <Collapse in={open} timeout='auto' unmountOnExit>
                        <Box margin={1}>
                          <Grid container spacing={3}>
                            <Grid item xs={3}>
                              <MuiPickersUtilsProvider utils={DateFnsUtils}>
                                <DatePicker
                                  autoOk
                                  inputVariant='outlined'
                                  variant='inline'
                                  label='Project start date'
                                  format={DISPLAY_DATE_FORMAT.replace(
                                    '/DD/YYYY',
                                    '/dd/yyyy'
                                  )}
                                  value={
                                    item.startDate === null
                                      ? null
                                      : moment(item.startDate, DB_DATE_FORMAT)._d
                                  }
                                  clearable
                                  onChange={e => {
                                    props.onProjectDatesChange(
                                      item.projectId,
                                      'startDate',
                                      moment(e)
                                    );
                                  }}
                                />
                              </MuiPickersUtilsProvider>
                            </Grid>
                            <Grid item xs={3}>
                              <MuiPickersUtilsProvider utils={DateFnsUtils}>
                                <DatePicker
                                  autoOk
                                  inputVariant='outlined'
                                  variant='inline'
                                  label='Project end date'
                                  format={DISPLAY_DATE_FORMAT.replace(
                                    '/DD/YYYY',
                                    '/dd/yyyy'
                                  )}
                                  value={
                                    item.endDate === null
                                      ? null
                                      : moment(item.endDate, DB_DATE_FORMAT)._d
                                  }
                                  clearable
                                  onChange={e => {
                                    props.onProjectDatesChange(
                                      item.projectId,
                                      'endDate',
                                      moment(e)
                                    );
                                  }}
                                />
                              </MuiPickersUtilsProvider>
                            </Grid>
                          </Grid>
                        </Box>
                      </Collapse>{' '}
                    </TableCell>
                  </TableRow>
                ) : null}
              </>
            ))}
          </TableBody>
        </Table>
      </TableContainer>
    </Paper>
  );
};

export default ProjectSelection;
